<div class="flex items-center gap-2 custom-form" [formGroup]="form">
  <!-- Start Date Picker -->
  <div class="flex flex-col w-full min-w-[180px] cursor-pointer" (click)="openStartPicker($event)">
    @let isStartInvalid = form.controls.startDate.invalid && form.controls.startDate.touched && !anyPickersOpen();

    <mat-form-field
      class="flex-1 [&_input]:pointer-events-none mat-mdc-form-field-type-mat-date-picker"
      [class.active-datepicker]="startRangePicker?.opened"
      [class.mat-form-field-invalid]="isStartInvalid"
    >
      <mat-label>
        {{ startDateLabel() || ('pages.campaignForm.sections.basics.startDatePlaceholder' | translate) }}
      </mat-label>
      <input readonly matInput [value]="form.controls.startDate.value | date: 'dd.MM.yyyy HH:mm'" />

      <div matSuffix class="flex items-center gap-1">
        <app-icon src="icons/chevron-down.svg" [size]="20" />
      </div>
      <mat-date-range-picker #startRangePicker></mat-date-range-picker>
      <mat-error [control]="form.controls.startDate" />

      <div class="opacity-0">
        <mat-date-range-input #startRangeInput="matDateRangeInput" [rangePicker]="startRangePicker">
          <input matStartDate formControlName="startDate" />
          <input matEndDate formControlName="endDate" />
        </mat-date-range-input>
      </div>
    </mat-form-field>

    @if (isStartInvalid) {
      <mat-error class="text-[10px] pl-[22px] pr-4" [control]="form.controls.startDate" />
    }
  </div>

  <!-- End Date Picker -->
  <div class="flex flex-col w-full min-w-[180px] cursor-pointer" (click)="openEndPicker($event)">
    @let isEndInvalid = form.controls.endDate.invalid && form.controls.endDate.touched && !anyPickersOpen();

    <mat-form-field
      class="flex-1 [&_input]:pointer-events-none mat-mdc-form-field-type-mat-date-picker"
      [class.active-datepicker]="endDatePicker?.opened"
      [class.mat-form-field-invalid]="isEndInvalid"
    >
      <mat-label>
        {{ endDateLabel() || ('pages.campaignForm.sections.basics.endDatePlaceholder' | translate) }}
      </mat-label>
      <input readonly matInput class="max-h-[48px]" [value]="form.controls.endDate.value | date: 'dd.MM.yyyy HH:mm'" />

      <div matSuffix class="flex items-center gap-1">
        <app-icon src="icons/chevron-down.svg" [size]="20" />
      </div>
      <mat-datepicker
        #endDatePicker
        [panelClass]="datePickerUtilities.endPickerPanelClass"
        [dateClass]="datePickerUtilities.endPickerDateClass(form.controls.startDate.value, form.controls.endDate.value)"
      ></mat-datepicker>
      <mat-error [control]="form.controls.endDate" />

      <div class="opacity-0">
        <input
          matInput
          [matDatepicker]="endDatePicker"
          [min]="form.controls.startDate.value"
          [value]="form.controls.endDate.value"
          (dateInput)="onEndDateChange($event.value ?? null)"
        />
      </div>
    </mat-form-field>

    @if (isEndInvalid) {
      <mat-error class="text-[10px] pl-[22px] pr-4" [control]="form.controls.endDate" />
    }
  </div>
</div>
